export enum EnumMyCourseMenu {
  /** 林曦老师亲授 */
  Teach = 'teach',
  /** 林曦老师监制 */
  Product = 'product',
  /** 线下课 */
  Offline = 'offline'
}

export enum EnumMyStudyMenu {
  /** 作业 */
  Homework = 'homework',
  /** 作品 */
  Reward = 'reward',
  /** 日常 */
  Daily = 'daily',
  /** 收藏 */
  Collect = 'collect'
}

export enum EnumMyAccountMenu {
  /** 订单 */
  Order = 'order',
  /** 笔山 */
  Bishan = 'bishan',
  /** 桐板儿 */
  Coin = 'coin',
  /** 卡劵 */
  Packs = 'packs',
  /** 兑换 */
  Exchange = 'exchange'
}

export enum EnumMySettingsMenu {
  /**
   * 个人资料
   */
  Myself = 'myself',
  /**
   * 通知消息
   */
  Notice = 'notice',
  /**
   * 账号设置
   */
  Account = 'account',
  /**
   * 隐私设置
   */
  Privacy = 'privacy'
}

export enum EnumMyAccountExchange {
  /** 卡劵列表 */
  List = 'list',
  /** 卡劵详情 */
  Detail = 'detail',
  /** 兑换记录 - 此处做切换界面用 */
  Record = 6
}

// 我的账户 - 卡劵筛选项
export enum EnumMyAccountPacksFilter {
  /** 全部 */
  All = 0,
  /** 福利劵 */
  WelfareCoupon = 1,
  /** 文房劵 */
  WenfangCoupon = 2,
  /** 伴学卡 */
  CompanionCard = 3,
  /** 已使用 */
  Used = 4,
  /** 已过期 */
  Expired = 5
}

// 个人主页tabs
export enum EnumMyTabs {
  /** 我的教室 */
  Index = '1',
  /** 我的课程 */
  Course = '2',
  /** 我的学习 */
  Study = '3',
  /** 我的账户 */
  Account = '4',
  /** 账号设置 */
  Settings = '5',
  /** 他人主页 */
  Center = '6'
}

export enum EnumMyAccountCount {
  /** 订单 */
  Order = 'order',
  /** 笔山 */
  Bishan = 'bishan',
  /** 桐板儿 */
  Coin = 'coin',
  /** 卡劵 */
  Packs = 'packs'
}

// 微信扫码弹窗类型枚举
export enum EnumWxImgPopType {
  Show = 'show',
  Day = 'day',
  Self = 'self'
}

export enum EnumMyCenterPrivacyConfig {
  /** 作业 */
  Homework = 'homework',
  /** 作品 */
  Reward = 'reward',
  /** 日常 */
  Daily = 'daily',
  /** 收藏 */
  Collect = 'collect',
  /** 精进值 */
  Experice = 'experice',
  /** 证书 */
  Certificate = 'certificate',
  /** 获奖 */
  Award = 'award',
  /** 正在学习 */
  Learning = 'learning',
  /** 学习数据 */
  StudyData = 'studyData'
}

// 个人特长
export enum EnumHobby {
  Photography = 1, // 摄影
  TakePhoto = 2, // 拍照
  EditVideo = 3, // 剪辑
  Design = 4, // 设计
  Write = 5, // 写作
  SceneLayout = 6, // 布景
  Instrument = 7, // 乐器
  FlowerArrange = 8, // 插花
  Tea = 9, // 喝茶
  Handcraft = 10, // 手工
  SealCarve = 11, // 篆刻
  Incense = 12, // 闻香
  Bake = 13, // 烘焙
  Sport = 14 // 运动
}

export enum EnumFollowStatus {
  /** 未关注 */
  No = 0,
  /** 已关注 */
  Yes = 1
}

/**
 * 桐学可查看我的作业列表
 */
export const FLAG_PRIVACY_HOMEWORK = 0b000000001
/**
 * 桐学可查看我的作品列表
 */
export const FLAG_PRIVACY_SHOW = 0b000000010
/**
 * 桐学可查看我的日常列表
 */
export const FLAG_PRIVACY_DAIRY = 0b000000100
/**
 * 桐学可查看我的收藏列表
 */
export const FLAG_PRIVACY_COLLECT = 0b000001000
/**
 * 桐学可查看我的精进值等级
 */
export const FLAG_PRIVACY_EXP = 0b000010000
/**
 * 桐学可查看我获得的证书
 */
export const FLAG_PRIVACY_CERT = 0b000100000
/**
 * 桐学可查看我的获奖情况
 */
export const FLAG_PRIVACY_AWARD = 0b001000000
/**
 * 桐学可查看我正在学习的课程
 */
export const FLAG_PRIVACY_LEARN = 0b010000000
/**
 * 桐学可查看我的学习情况数据
 */
export const FLAG_PRIVACY_DATA = 0b100000000
